var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 31,
    viewBox: "0 0 28 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 21.7692H27.5M3.61538 21.7692V11.3846C3.61538 5.64935 8.26474 1 14 1C19.7353 1 24.3846 5.64935 24.3846 11.3846V21.7692M9.84615 24.8846V25.9231C9.84615 28.2172 11.7059 30.0769 14 30.0769C16.2941 30.0769 18.1538 28.2172 18.1538 25.9231V24.8846",
    stroke: "#373737",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.9e06c25f2c48d6df20316a89f276f006.svg";
export { ForwardRef as ReactComponent };